module.exports = __webpack_public_path__ + "img/13.b90de3c3.png";